__webpack_require__.p = "https://lora-sdk.belive.sg/embed-js/staging/";